import type { JSX } from 'react'
export const PostListEmptyStateIllustration = (): JSX.Element => {
  return (
    <svg
      width="204"
      height="124"
      viewBox="0 0 204 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.9999 52.8047L67.9999 65.5342C67.9997 65.8101 67.7759 66.0342 67.4999 66.0342C67.2239 66.0341 67.0001 65.8101 66.9999 65.5342L66.9999 52.8047C66.9999 23.588 93.6082 1.30605e-05 126.305 -6.10022e-06C158.98 -3.24367e-06 185.609 20.4074 185.609 52.8047L185.609 110.903L195.307 102.221C195.499 102.049 195.793 102.065 195.964 102.257C196.136 102.448 196.12 102.743 195.928 102.914L185.377 112.358C185.201 112.517 184.933 112.517 184.756 112.358L174.237 102.914C174.046 102.742 174.03 102.448 174.202 102.257C174.373 102.066 174.668 102.049 174.859 102.221L184.609 110.974L184.609 52.8047C184.609 21.1036 158.583 0.999997 126.305 0.999994C94.0472 1.00001 67.9999 24.2472 67.9999 52.8047Z"
        fill="var(--color-illustration-element)"
      />
      <g filter="url(#filter0_d_686_64358)">
        <rect
          x="53"
          y="28.9971"
          width="99"
          height="93"
          rx="7.38007"
          fill="var(--color-illustration-card)"
          shapeRendering="crispEdges"
        />
        <rect
          x="53.5"
          y="29.4971"
          width="98"
          height="92"
          rx="6.88007"
          stroke="var(--color-illustration-border)"
          shapeRendering="crispEdges"
        />
        <path
          d="M78.4863 39.9971C86.4869 39.9971 92.9727 46.4828 92.9727 54.4834C92.9727 57.8688 91.8102 60.9819 89.8643 63.4482L96.501 70.085C97.1664 70.7506 97.1665 71.8296 96.501 72.4951C95.8354 73.1605 94.7564 73.1605 94.0908 72.4951L87.4551 65.8594C84.9882 67.8069 81.8732 68.9697 78.4863 68.9697C70.4858 68.9697 64 62.484 64 54.4834C64 46.4828 70.4858 39.9971 78.4863 39.9971ZM78.4883 43.543C72.4463 43.543 67.5479 48.4414 67.5479 54.4834C67.5479 60.5254 72.4463 65.4229 78.4883 65.4229C84.5302 65.4228 89.4277 60.5253 89.4277 54.4834C89.4277 48.4414 84.5302 43.543 78.4883 43.543Z"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="64"
          y="93"
          width="68"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="64"
          y="105"
          width="79"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
      </g>
      <rect
        x="167.5"
        y="40.5"
        width="36"
        height="34"
        rx="6.88007"
        fill="var(--color-illustration-card)"
      />
      <rect
        x="167.5"
        y="40.5"
        width="36"
        height="34"
        rx="6.88007"
        stroke="var(--color-illustration-border)"
      />
      <path
        d="M181.966 64.3165C183.573 65.1406 185.421 65.3638 187.178 64.9459C188.934 64.528 190.484 63.4965 191.547 62.0372C192.61 60.5778 193.117 58.7867 192.977 56.9866C192.837 55.1865 192.058 53.4957 190.781 52.2189C189.504 50.9422 187.814 50.1634 186.013 50.023C184.213 49.8825 182.422 50.3897 180.963 51.453C179.504 52.5163 178.472 54.0658 178.054 55.8224C177.636 57.579 177.859 59.4271 178.684 61.0336L177 66L181.966 64.3165Z"
        fill="var(--color-illustration-element)"
      />
      <rect
        x="0.5"
        y="87.5"
        width="36"
        height="34"
        rx="6.88007"
        fill="var(--color-illustration-card)"
      />
      <rect
        x="0.5"
        y="87.5"
        width="36"
        height="34"
        rx="6.88007"
        stroke="var(--color-illustration-border)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6997 111.713C18.2975 112.096 17.7025 112.096 17.3003 111.713L16.84 111.276C12.72 107.358 10 104.773 10 101.609C10 99.0239 11.932 97 14.4 97C15.792 97 17.128 97.6788 18 98.7473C18.872 97.6788 20.208 97 21.6 97C24.068 97 26 99.0239 26 101.609C26 104.773 23.28 107.358 19.16 111.276L18.6997 111.713Z"
        fill="var(--color-illustration-element)"
      />
      <defs>
        <filter
          id="filter0_d_686_64358"
          x="53"
          y="28.9971"
          width="99"
          height="94.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.6" />
          <feComposite in2="hardAlpha" operator="out" result="offsetAlpha" />
          <feFlood
            floodColor="var(--color-illustration-border)"
            floodOpacity="1"
            result="shadowColor"
          />
          <feComposite
            in="shadowColor"
            in2="offsetAlpha"
            operator="in"
            result="shadow"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_686_64358"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_686_64358"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
